import styled from "styled-components";
import { includeStyledSystem, sx } from "../util/styledSystem";
/** Basic building block */
export const Box = styled.div `
  box-sizing: border-box;
  min-width: 0;
  ${includeStyledSystem()}
  ${sx}
`;
